import {
  SvgCardhand,
  SvgCompany,
  SvgContract,
  SvgNavBarBills,
  SvgNavBarDashboard,
} from '@edenredespana/oreneta'

import type { SidebarMenuItemModel } from '@/Shared/ui/navigation'
import { navigationTranslation } from '@/Shared/ui/navigation/navigationTranslation'
import { navigationRoutes } from '@/Shared/ui/routers'
import { UserType } from '@/User/domain'
import { storesTranslation } from '@/Store/ui/storesTranslation'


export const sidebarMenu: SidebarMenuItemModel[] = [
  {
    title: navigationTranslation.sidebar.items.home,
    icon: <SvgNavBarDashboard />,
    link: navigationRoutes.home,
  },
  {
    items: [
      {
        title: navigationTranslation.sidebar.items.invoices,
        icon: <SvgNavBarBills />,
        link: navigationRoutes.invoices,
      },
    ],
  },
  {
    items: [
      {
        title: navigationTranslation.sidebar.items.transactions,
        icon: <SvgCardhand />,
        link: navigationRoutes.transactions,
      },
    ],
  },
  {
    items: [
      {
        title: navigationTranslation.sidebar.sections.store,
        icon: <SvgCompany />,
        childs: [
          {
            title: navigationTranslation.sidebar.items.storeData,
            link: navigationRoutes.storeData,
          },
          {
            title: navigationTranslation.sidebar.items.storeTPV,
            link: navigationRoutes.storeTPV,
            userTypeExclusive: [UserType.RESTAURANT],
          },
          {
            title: navigationTranslation.sidebar.items.storeStickers,
            link: navigationRoutes.storeStickers,
          },
          {
            title: navigationTranslation.sidebar.items.storeContacts,
            link: navigationRoutes.storeContacts,
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        title: navigationTranslation.sidebar.sections.contracts,
        icon: <SvgContract />,
        userTypeExclusive: [UserType.RESTAURANT, UserType.NURSERY],
        childs: [
          {
            title: navigationTranslation.sidebar.items.contractsProducts,
            link: navigationRoutes.contractsProductsData,
          },
          {
            title: navigationTranslation.sidebar.items.contractsData,
            link: navigationRoutes.contractsBillingData,
          },
        ],
      },
    ],
  },
]

export const sidebarGuarderiaMenu: SidebarMenuItemModel[] = [
  {
    title: navigationTranslation.sidebar.items.home,
    icon: <SvgNavBarDashboard />,
    link: navigationRoutes.home,
  },
  {
    items: [
      {
        title: navigationTranslation.sidebar.items.invoices,
        icon: <SvgNavBarBills />,
        link: navigationRoutes.invoices,
      },
    ],
  },
  {
    items: [
      {
        title: navigationTranslation.sidebar.items.transactions,
        icon: <SvgCardhand />,
        link: navigationRoutes.transactions,
      },
    ],
  },
  {
    items: [
      {
        title: storesTranslation.myStore.sideBarGuarderia,
        icon: <SvgCompany />,
        childs: [
          {
            title: storesTranslation.myStore.pageTitleGuarderia,
            link: navigationRoutes.storeData,
          },
          {
            title: navigationTranslation.sidebar.items.storeTPV,
            link: navigationRoutes.storeTPV,
            userTypeExclusive: [UserType.RESTAURANT],
          },
          {
            title: navigationTranslation.sidebar.items.storeStickers,
            link: navigationRoutes.storeStickers,
          },
          {
            title: navigationTranslation.sidebar.items.storeContacts,
            link: navigationRoutes.storeContacts,
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        title: navigationTranslation.sidebar.sections.contracts,
        icon: <SvgContract />,
        childs: [
          {
            title: navigationTranslation.sidebar.items.contractsProducts,
            link: navigationRoutes.contractsProductsData,
          },
          {
            title: navigationTranslation.sidebar.items.contractsData,
            link: navigationRoutes.contractsBillingData,
          },
        ],
      },
    ],
  },
]
